/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import {
  Input, Modal, Form, Select,
} from 'antd';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import locales from '../../../../utils/i18n/messages/texts';


const { Option } = Select;
const AddUserModal = ({
  onCloseModal, onSaveModal,
}) => {
  const [form] = Form.useForm();

  const onOk = () => {
    form.submit();
  };

  return (
    <Modal
      title={<FormattedMessage id={locales.newUserModalTitle.id} />}
      visible
      onOk={onOk}
      onCancel={onCloseModal}
      cancelText="Отмена"
      okText="Добавить"
    >
      <Form form={form} layout="vertical" name="addUserForm" onFinish={onSaveModal}>
        <Form.Item
          label="Фамилия"
          name="lastName"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="Имя"
          name="firstName"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="Отчество"
          name="middleName"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="Сокращенное название учреждения"
          name="shortName"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="Полное название учреждения"
          name="fullName"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="E-mail"
          name="email"
          rules={[{ required: true, type: 'email' }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="Телефон"
          name="phone"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
        <Form.Item
          label="ИНН"
          name="INN"
          rules={[{ required: true }]}
        >
          <Input style={{ marginBottom: '20px' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddUserModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onSaveModal: PropTypes.func.isRequired,
};

export default AddUserModal;
